/** Confines a playback position to 0..1. */
export const clampFraction = (value: number) => Math.min(1, Math.max(0, value));
